import { render, staticRenderFns } from "./DictConfig.vue?vue&type=template&id=24e69ceb&scoped=true"
import script from "./DictConfig.vue?vue&type=script&lang=js"
export * from "./DictConfig.vue?vue&type=script&lang=js"
import style0 from "./DictConfig.vue?vue&type=style&index=0&id=24e69ceb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e69ceb",
  null
  
)

export default component.exports